var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroBrowserChromeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.555,
    height: 72.549,
    viewBox: "0 0 72.555 72.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(-238.028 -414.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M61.818,12.658a36.265,36.265,0,0,1,59.821,7.174c-8.23,0-21.113,0-28.092,0-5.061,0-8.33-.113-11.867,1.75A16.73,16.73,0,0,0,73.286,32.6Z",
    transform: "translate(184.97 414.445)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M170.842,182.962A12.058,12.058,0,1,0,182.9,170.9,12.073,12.073,0,0,0,170.842,182.962Z",
    transform: "translate(91.396 267.78)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M40.943,151.841a16.248,16.248,0,0,1-19.023-7.709c-3.31-5.714-12.062-20.955-16.035-27.888-13.93,21.349-1.927,50.439,23.358,55.4Z",
    transform: "translate(238.028 314.691)",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M253.421,170.841a16.515,16.515,0,0,1,3.047,20.311c-2.875,4.961-12.058,20.456-16.506,27.956a36.3,36.3,0,0,0,36.463-48.271Z",
    transform: "translate(32.07 267.835)",
    fill: "#ffc107"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroBrowserChromeIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroBrowserChromeIcon.5ee4e0ca45bd6e6a96e25be05d827f8d.svg";
export { ForwardRef as ReactComponent };